import mysql from 'mysql2/promise'

// En dev, le hot-reload réexécute ce module et recrée un pool à chaque fois,
// laissant fuir les connexions jusqu'à saturer MySQL ("Trop de connexions").
// On garde donc un pool unique sur l'objet global.
const globalForDb = globalThis as unknown as { _mysqlPool?: mysql.Pool }

const pool =
  globalForDb._mysqlPool ??
  mysql.createPool({
    host: process.env.DB_HOST || '127.0.0.1',
    port: parseInt(process.env.DB_PORT || '3306'),
    user: process.env.DB_USER || 'root',
    password: process.env.DB_PASSWORD || '',
    database: process.env.DB_NAME || 'inv',
    waitForConnections: true,
    connectionLimit: 10,
    maxIdle: 10,
    idleTimeout: 60000,
    enableKeepAlive: true,
    charset: 'utf8mb4',
  })

if (process.env.NODE_ENV !== 'production') globalForDb._mysqlPool = pool

export async function query<T = any>(sql: string, params?: any[]): Promise<T[]> {
  const [rows] = await pool.execute(sql, params)
  return rows as T[]
}

export async function queryOne<T = any>(sql: string, params?: any[]): Promise<T | null> {
  const rows = await query<T>(sql, params)
  return rows[0] ?? null
}

export function uuid() {
  return crypto.randomUUID()
}

export default pool
